"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.objectTypeToOrderPriority = exports.stringToObjectType = exports.ObjectType = void 0;
var ObjectType;

(function (ObjectType) {
  ObjectType["Unknown"] = ""; //oma-label (0-1023)

  ObjectType["Security"] = "0";
  ObjectType["Server"] = "1";
  ObjectType["AccessControl"] = "2";
  ObjectType["Device"] = "3";
  ObjectType["Connectivity"] = "4";
  ObjectType["FirmwareUpdate"] = "5";
  ObjectType["Location"] = "6";
  ObjectType["ConnectivityStats"] = "7";
  ObjectType["LockAndWipe"] = "8";
  ObjectType["SoftwareManagement"] = "9";
  ObjectType["CellularConnectivity"] = "10";
  ObjectType["APN"] = "11";
  ObjectType["WLAN"] = "12";
  ObjectType["BearerSelection"] = "13";
  ObjectType["LWM2MSoftwareComponent"] = "14";
  ObjectType["DeviceCapabilityManagement"] = "15";
  ObjectType["Portfolio"] = "16";
  ObjectType["CommunicationCharacteristics"] = "17";
  ObjectType["NonAccessStratum"] = "18";
  ObjectType["BinaryAppDataContainer"] = "19";
  ObjectType["EventLog"] = "20";
  ObjectType["OSCORE"] = "21"; // ext-label space (2048 - 10240)

  ObjectType["DigitialInput"] = "3200";
  ObjectType["DigitialOutput"] = "3201";
  ObjectType["AnalogInput"] = "3202";
  ObjectType["AnalogOutput"] = "3203";
  ObjectType["Sensor"] = "3300";
  ObjectType["Illuminance"] = "3301";
  ObjectType["Presence"] = "3302";
  ObjectType["Temperature"] = "3303";
  ObjectType["Humidity"] = "3304";
  ObjectType["PowerMeasurement"] = "3305";
  ObjectType["Actuation"] = "3306";
  ObjectType["SetPoint"] = "3308";
  ObjectType["LoadControl"] = "3310";
  ObjectType["LightControl"] = "3311";
  ObjectType["PowerControl"] = "3312";
  ObjectType["Accelerometer"] = "3313";
  ObjectType["Magnetometer"] = "3314";
  ObjectType["Barometer"] = "3315";
  ObjectType["Voltage"] = "3316";
  ObjectType["Current"] = "3317";
  ObjectType["Frequency"] = "3318";
  ObjectType["Percentage"] = "3320";
  ObjectType["Load"] = "3322";
  ObjectType["Pressure"] = "3323";
  ObjectType["Concentration"] = "3325";
  ObjectType["Power"] = "3328";
  ObjectType["PowerFactor"] = "3329";
  ObjectType["Energy"] = "3331";
  ObjectType["Time"] = "3333";
  ObjectType["TextDisplay"] = "3341";
  ObjectType["OnOffSwitch"] = "3342";
  ObjectType["Dimmer"] = "3343";
  ObjectType["Rate"] = "3346";
  ObjectType["PushButton"] = "3347";
  ObjectType["Anomality"] = "7050";
  ObjectType["LegacyHeat"] = "7051"; // x-label (10241-42768)

  ObjectType["ElectricityThreePhase"] = "10242";
  ObjectType["ElectricityPhase"] = "10243";
  ObjectType["HeatingCooling"] = "10257"; // Comsel specific (conflicting with OMA)

  ObjectType["ElectricVehicleChargingStation"] = "10259";
  ObjectType["Gas"] = "10260";
  ObjectType["Water"] = "10261";
  ObjectType["HeatCostAllocator"] = "10264";
  ObjectType["MbusOther"] = "10265";
  ObjectType["ColdWater"] = "10266";
  ObjectType["HotWater"] = "10267";
  ObjectType["RoomSensor"] = "10269";
  ObjectType["Fan"] = "10270"; // Legacy to be replaced

  ObjectType["HeatingCoolingLegacy"] = "7030";
  ObjectType["HeatingCoolingTypo"] = "10258";
  ObjectType["GasFior"] = "10263";
})(ObjectType = exports.ObjectType || (exports.ObjectType = {}));

;

function stringToObjectType(str) {
  if (str === "") {
    return ObjectType.Unknown;
  } else if (str === "0") {
    return ObjectType.Security;
  } else if (str === "1") {
    return ObjectType.Server;
  } else if (str === "2") {
    return ObjectType.AccessControl;
  } else if (str === "3") {
    return ObjectType.Device;
  } else if (str === "4") {
    return ObjectType.Connectivity;
  } else if (str === "5") {
    return ObjectType.FirmwareUpdate;
  } else if (str === "6") {
    return ObjectType.Location;
  } else if (str === "7") {
    return ObjectType.ConnectivityStats;
  } else if (str === "8") {
    return ObjectType.LockAndWipe;
  } else if (str === "9") {
    return ObjectType.SoftwareManagement;
  } else if (str === "10") {
    return ObjectType.CellularConnectivity;
  } else if (str === "11") {
    return ObjectType.APN;
  } else if (str === "12") {
    return ObjectType.WLAN;
  } else if (str === "13") {
    return ObjectType.BearerSelection;
  } else if (str === "14") {
    return ObjectType.LWM2MSoftwareComponent;
  } else if (str === "15") {
    return ObjectType.DeviceCapabilityManagement;
  } else if (str === "16") {
    return ObjectType.Portfolio;
  } else if (str === "17") {
    return ObjectType.CommunicationCharacteristics;
  } else if (str === "18") {
    return ObjectType.NonAccessStratum;
  } else if (str === "19") {
    return ObjectType.BinaryAppDataContainer;
  } else if (str === "20") {
    return ObjectType.EventLog;
  } else if (str === "21") {
    return ObjectType.OSCORE;
  } else if (str === "3200") {
    return ObjectType.DigitialInput;
  } else if (str === "3201") {
    return ObjectType.DigitialOutput;
  } else if (str === "3202") {
    return ObjectType.AnalogInput;
  } else if (str === "3203") {
    return ObjectType.AnalogOutput;
  } else if (str === "3300") {
    return ObjectType.Sensor;
  } else if (str === "3301") {
    return ObjectType.Illuminance;
  } else if (str === "3302") {
    return ObjectType.Presence;
  } else if (str === "3303") {
    return ObjectType.Temperature;
  } else if (str === "3304") {
    return ObjectType.Humidity;
  } else if (str === "3305") {
    return ObjectType.PowerMeasurement;
  } else if (str === "3306") {
    return ObjectType.Actuation;
  } else if (str === "3308") {
    return ObjectType.SetPoint;
  } else if (str === "3310") {
    return ObjectType.LoadControl;
  } else if (str === "3311") {
    return ObjectType.LightControl;
  } else if (str === "3312") {
    return ObjectType.PowerControl;
  } else if (str === "3313") {
    return ObjectType.Accelerometer;
  } else if (str === "3314") {
    return ObjectType.Magnetometer;
  } else if (str === "3315") {
    return ObjectType.Barometer;
  } else if (str === "3316") {
    return ObjectType.Voltage;
  } else if (str === "3317") {
    return ObjectType.Current;
  } else if (str === "3318") {
    return ObjectType.Frequency;
  } else if (str === "3320") {
    return ObjectType.Percentage;
  } else if (str === "3322") {
    return ObjectType.Load;
  } else if (str === "3323") {
    return ObjectType.Pressure;
  } else if (str === "3325") {
    return ObjectType.Concentration;
  } else if (str === "3328") {
    return ObjectType.Power;
  } else if (str === "3329") {
    return ObjectType.PowerFactor;
  } else if (str === "3331") {
    return ObjectType.Energy;
  } else if (str === "3333") {
    return ObjectType.Time;
  } else if (str === "3341") {
    return ObjectType.TextDisplay;
  } else if (str === "3342") {
    return ObjectType.OnOffSwitch;
  } else if (str === "3343") {
    return ObjectType.Dimmer;
  } else if (str === "3346") {
    return ObjectType.Rate;
  } else if (str === "3347") {
    return ObjectType.PushButton;
  } else if (str === "7050") {
    return ObjectType.Anomality;
  } else if (str === "10242") {
    return ObjectType.ElectricityThreePhase;
  } else if (str === "10243") {
    return ObjectType.ElectricityPhase;
  } else if (str === "10257") {
    return ObjectType.HeatingCooling;
  } else if (str === "10259") {
    return ObjectType.ElectricVehicleChargingStation;
  } else if (str === "10260") {
    return ObjectType.Gas;
  } else if (str === "10261") {
    return ObjectType.Water;
  } else if (str === "10264") {
    return ObjectType.HeatCostAllocator;
  } else if (str === "10265") {
    return ObjectType.MbusOther;
  } else if (str === "10266") {
    return ObjectType.ColdWater;
  } else if (str === "10267") {
    return ObjectType.HotWater;
  } else if (str === "10269") {
    return ObjectType.RoomSensor;
  } else if (str === "10270") {
    return ObjectType.Fan;
  } else if (str === "7030") {
    return ObjectType.HeatingCoolingLegacy;
  } else if (str === "10258") {
    return ObjectType.HeatingCoolingTypo;
  } else if (str === "10263") {
    return ObjectType.GasFior;
  }

  return ObjectType.Unknown;
}

exports.stringToObjectType = stringToObjectType;

function objectTypeToOrderPriority(object) {
  if (object === ObjectType.ElectricityPhase) {
    return 1;
  }

  if (object === ObjectType.ElectricityThreePhase) {
    return 2;
  }

  if (object === ObjectType.ElectricVehicleChargingStation) {
    return 3;
  }

  if (object === ObjectType.HeatingCooling) {
    return 4;
  }

  if (object === ObjectType.HeatCostAllocator) {
    return 5;
  }

  if (object === ObjectType.Gas) {
    return 6;
  }

  if (object === ObjectType.Water) {
    return 7;
  }

  if (object === ObjectType.HotWater) {
    return 8;
  }

  if (object === ObjectType.ColdWater) {
    return 9;
  }

  if (object === ObjectType.RoomSensor) {
    return 10;
  }

  if (object === ObjectType.Fan) {
    return 11;
  }

  if (object === ObjectType.MbusOther) {
    return 12;
  } // legacy


  if (object === ObjectType.PowerMeasurement) {
    return 13;
  }

  if (object === ObjectType.Voltage) {
    return 14;
  }

  if (object === ObjectType.Current) {
    return 15;
  }

  if (object === ObjectType.Frequency) {
    return 16;
  }

  if (object === ObjectType.LegacyHeat) {
    return 17;
  }

  return 10270 - parseInt(object);
}

exports.objectTypeToOrderPriority = objectTypeToOrderPriority;